import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { DriverGroup } from '../schemas/driver-group.schema';

/**
 * Updates a Driver Group
 * @param driverGroup The Driver Group being updated
 * @returns Data Object containing whether the driver group was edited
 */
export function putDriverGroupsId(
  this: unknown,
  driverGroup: Partial<DriverGroup>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).driverGroupsUrl}/${
          driverGroup.driverGroupId ?? -1
        }`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            ...driverGroup,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
        message: z.string().nullable(),
      })
    )
  );
}
